import React from "react";
import {Modal} from "react-bootstrap";
import Moment from "react-moment";
import ReactStars from "react-rating-stars-component";
import authService from "../../../_services/cart/authService";

/**
 * Todas las reseñas que recibió el vendedor.
 *
 * <p>No pagina: vienen enteras en el `findById` del usuario, así que el modal sólo las despliega.
 * Si alguna vez una cuenta junta tantas como para que eso pese, el corte es pasarlas a
 * {@code /api/admin/users/resumen} y paginarlas ahí, no acá.
 */
const ReseniasUsuarioModal = ({usuario, resenias, show, handleClose}) => (
    <Modal size="lg" show={show} onHide={handleClose} scrollable={true}>
        <Modal.Header closeButton>
            <Modal.Title>
                Reseñas de {authService.formatUserName(usuario)}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {resenias.length === 0 && <p>Todavía no recibió ninguna reseña.</p>}

            <ul className="user-detail__resenias">
                {resenias.map((review, i) => (
                    // Sin `key={review.id}`: la proyección que sirve las reseñas no trae el id.
                    <li className="user-detail__resenia" key={i}>
                        <div className="user-detail__resenia-head">
                            <span className="user-detail__resenia-autor">
                                {review.buyerMemberAccount?.username ?? "Comprador"}
                            </span>
                            <ReactStars value={review.rating} edit={false} size={16}
                                        isHalf={true} activeColor="#ffd700"/>
                            {review.createdInstant && (
                                <Moment className="user-detail__resenia-fecha"
                                        date={review.createdInstant} format="DD/MM/YYYY"/>
                            )}
                        </div>
                        {review.title && <p className="user-detail__resenia-titulo">{review.title}</p>}
                        {review.observation && (
                            <p className="user-detail__resenia-texto">{review.observation}</p>
                        )}
                    </li>
                ))}
            </ul>
        </Modal.Body>
        <Modal.Footer>
            <button className="button" data-type="secondary" type="button" onClick={handleClose}>
                Cerrar
            </button>
        </Modal.Footer>
    </Modal>
);

export {ReseniasUsuarioModal};
